<template>
  <div>
    <div
      class="custom-popup-class d-sm-down-none"
      v-if="popupclassdetail === true"
      style="z-index: 1"
    >
      <div
        style="
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <br /><br /><br />
        <div style="position: fixed">
          <div class="text-center p-2">
            <img
              src="../assets/img/icon/vectorQuiz.svg"
              style="height: 300px"
            />
          </div>
          <div class="card-custom-web-detail p-3">
            <h5 class="ml-4">
              <b>{{ detail.Title }}</b>
            </h5>
            <CRow>
              <CCol sm="12">
                <img src="../assets/img/icon/book.svg" /><b class="ml-2"
                  >Quiz Details</b
                >
                <br />
                <label class="ml-2">
                  {{ detail.subjectName }} ( {{ detail.gradeName }} ) </label
                ><br />
                <label class="ml-2">
                  {{ detail.questionCount }} question
                </label></CCol
              >
              <hr />
              <br />

              <CCol sm="12">
                <img src="../assets/img/icon/clock.svg" /><b class="ml-2"
                  >Time</b
                >
                <br />
                <label class="ml-2"> {{ detail.TimerString }}</label>
                <span
                  v-html="detail.Description"
                  style="font-size:font-size: 1rem;line-height: 1.5rem;"
                  class="display-6 text-left"
                >
                  >
                </span>
              </CCol>
            </CRow>
            <br />
            <div style="overflow-y: scroll; height: 300px">
              <div class="text-center">
                <CButton
                  type="button"
                  color="primary"
                  class="btn custom-btn-login-forgot btn-info"
                  @click="GoToQuizName(detail.Id)"
                  >Start Quiz</CButton
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="custom-popup-class-md d-md-none"
      v-if="popupclassdetail === true"
      style="z-index: 1"
    >
      <div
        style="
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <br /><br /><br />
        <div style="position: fixed">
          <h3 class="custom-24px text-left text-white mt-3 p-2">
            <div class="text-center">
              <img
                src="../assets/img/icon/vectorQuiz.svg"
                style="height: 200px"
              />
            </div>
          </h3>
          <div class="card-custom-web-detail p-3">
            <h5>
              <b>{{ detail.Title }}</b>
            </h5>
            <CRow>
              <CCol sm="12">
                <img src="../assets/img/icon/book.svg" /><b class="ml-2"
                  >Quiz Details</b
                >
                <br />
                <label class="ml-2">
                  {{ detail.subjectName }} ( {{ detail.gradeName }} ) </label
                ><br />
                <label class="ml-2">
                  {{ detail.questionCount }} question
                </label></CCol
              >
              <hr />
              <br />

              <CCol sm="12">
                <img src="../assets/img/icon/clock.svg" /><b class="ml-2"
                  >Time</b
                >
                <br />
                <label class="ml-2"> {{ detail.TimerString }}</label>
                <span
                  v-html="detail.Description"
                  style="font-size:font-size: 1rem;line-height: 1.5rem;"
                  class="display-6 text-left"
                >
                  >
                </span>
              </CCol>
            </CRow>

            <div class="text-center">
              <CButton
                type="button"
                color="primary"
                class="btn custom-btn-login-forgot btn-info"
                @click="GoToQuizName(detail.Id)"
                >Start Quiz</CButton
              >
            </div>
            <CModal size="md" :show.sync="ModalPopup">
              <h4 class="text-center">Let's Register with Pickiddo</h4>
              <CCol sm="12">
                <label class="text-center m-0"
                  >To continue with class booking, please login or create an
                  account below.</label
                >
                <br />
                <div class="text-center">
                  <!-- <CButton
                    :href="
                      'https://pickiddo.com/OnlineClass/#/SignUp?targetUrl=%2FJoinGroup%3FcodeId%3D' +
                      packages.ScheduleId
                    "
                    class="btn custom-btn-login-forgot btn-info"
                    >Register Pickiddo</CButton
                  >
                  <CButton
                    :href="
                      'https://pickiddo.com/OnlineClass/#/Login?targetUrl=%2FJoinGroup%3FcodeId%3D' +
                      packages.ScheduleId
                    "
                    class="btn custom-btn-login-active-signin btn-info"
                    >Login to existing account</CButton
                  > -->
                </div>
              </CCol>
            </CModal>
          </div>
        </div>
      </div>
    </div>

    <!-- login or register -->

    <div
      class="custom-popup-class d-sm-down-none"
      v-if="popuplogin === true"
      style="z-index: 1"
    >
      <div
        style="
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <br /><br /><br />
        <div style="position: fixed; width: 50%">
          <h3 class="custom-24px text-left text-white mt-3 p-2">
            <img
              src="../assets/img/icon/VectorLeft.svg"
              @click="GoBack()"
              class="mr-2"
            />
            {{ detail.Title }}
          </h3>
          <div class="card-custom-web-detail p-3 text-center">
            <br />
            <div v-if="loginexisting === true">
              <b>To answer quiz, you need to Login</b>
              <br /><br />

              <CButton
                type="button"
                color="primary"
                class="btn custom-btn-login-forgot btn-info text-left"
                @click="LoginExistingAccount(detail.Id)"
                >Login Existing Account</CButton
              >

              <br />
              <CButton
                type="button"
                color="primary"
                class="btn custom-btn-login-forgot btn-info text-left"
                @click="SignUp(detail.Id)"
                >Sign Up</CButton
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="custom-popup-class-md d-md-none"
      v-if="popuplogin === true"
      style="z-index: 1"
    >
      <div
        style="
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <br /><br /><br />
        <div style="position: fixed">
          <h3 class="custom-24px text-left text-white mt-3 p-2">
            <img
              src="../assets/img/icon/VectorLeft.svg"
              @click="GoBack()"
              class="mr-2"
            />
            {{ detail.Title }}
          </h3>
          <div class="card-custom-web-detail p-3">
            <h5>
              <b>What is your name?</b>
              <br />
              <br />
              <CInput
                type="text"
                v-model="StudentName"
                placeholder="Enter your name"
                style="width: 80%"
              />
              <div class="text-center">
                <CButton
                  type="button"
                  color="primary"
                  class="btn custom-btn-login-forgot btn-info"
                  @click="InsertManualStudent(detail.Id)"
                  >Next</CButton
                >
              </div>
            </h5>
          </div>
        </div>
      </div>
    </div>

    <!-- select child -->

    <div
      class="custom-popup-class d-sm-down-none"
      v-if="popupquizname === true"
      style="z-index: 1"
    >
      <div
        style="
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <br /><br /><br />
        <div style="position: fixed; width: 100%">
          <h3 class="custom-24px text-left text-white mt-3 p-2">
            <img
              src="../assets/img/icon/VectorLeft.svg"
              @click="GoBack()"
              class="mr-2"
            />
            {{ detail.Title }}
          </h3>
          <div class="card-custom-web-detail p-3">
            <br />
            <b>What is your name?</b>
            <br /><br />
            <CInput
              type="text"
              v-model="StudentName"
              placeholder="Enter your name"
            />
            <CButton
              type="button"
              color="primary"
              class="btn custom-btn-login-forgot btn-info text-left"
              @click="InsertManualStudent(detail.Id)"
              >Next</CButton
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="custom-popup-class-md d-md-none"
      v-if="popupquizname === true"
      style="z-index: 1"
    >
      <div
        style="
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <br /><br /><br />
        <div style="position: fixed">
          <h3 class="custom-24px text-left text-white mt-3 p-2">
            <img
              src="../assets/img/icon/VectorLeft.svg"
              @click="GoBack()"
              class="mr-2"
            />
            {{ detail.Title }}
          </h3>
          <div class="card-custom-web-detail p-3">
            <h5>
              <b>What is your name?</b>
              <br />
              <br />
              <CInput
                type="text"
                v-model="StudentName"
                placeholder="Enter your name"
                style="width: 80%"
              />
              <div class="text-center">
                <CButton
                  type="button"
                  color="primary"
                  class="btn custom-btn-login-forgot btn-info"
                  @click="InsertManualStudent(detail.Id)"
                  >Next</CButton
                >
              </div>
            </h5>
          </div>
        </div>
      </div>
    </div>

    <div
      style="
        background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
      "
    >
      <CRow class="ml-5 mr-5 mb-5">
        <Mainlayout></Mainlayout>
        <br /><br /><br />
      </CRow>

      <CContainer>
        <div class="text-center d-sm-down-none">
          <h3 class="custom-64px text-white text-center">Quizes for You</h3>
          <div class="mt-5">
            <CButton
              color="info"
              class="custom-btn-login-forgot"
              @click="ShowPrimary()"
              :style="
                isShowPrimary
                  ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                  : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
              "
            >
              Primary School</CButton
            >

            <CButton
              color="info"
              class="custom-btn-login-forgot ml-2"
              @click="ShowSecondary()"
              :style="
                isShowSecondary
                  ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                  : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
              "
            >
              Secondary School</CButton
            >
          </div>
        </div>

        <div class="text-center d-md-none">
          <h3 class="custom-32px text-white text-center">Quizes for You</h3>
          <div class="mt-5">
            <CButton
              color="info"
              class="custom-btn-login-forgot"
              @click="ShowPrimary()"
              :style="
                isShowPrimary
                  ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                  : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
              "
            >
              Primary School</CButton
            >

            <br /><br />
            <CButton
              color="info"
              class="custom-btn-login-forgot"
              @click="ShowSecondary()"
              :style="
                isShowSecondary
                  ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                  : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
              "
            >
              Secondary School</CButton
            >
          </div>
        </div>
      </CContainer>

      <CRow v-if="PrimarySchool === true">
        <div class="card-custom-web">
          <div class="text-center">
            <h1 class="ml-5 mt-5 custom-64px text-center d-sm-down-none">
              <strong>Available Quiz to Participate</strong>
            </h1>

            <h1 class="ml-5 mt-5 custom-24px text-center d-md-none">
              <strong>Available Quiz to Participate</strong>
            </h1>

            <label class="ml-2 mr-2 d-sm-down-none"
              >Choose the subjects that match with your desire.</label
            >
            <label class="ml-2 mr-2 d-md-none"
              >Choose the subjects that match with your desire.</label
            >

            <br />
            <CContainer>
              <div class="mt-5 mb-3">
                <div class="">
                  <CCol sm="12" class="">
                    <CRow class="">
                      <CCol sm="6">
                        <label style="text-align: center"> Select Grade</label>
                        <v-select
                          v-model="SelectedGrade"
                          :options="gradeOptions"
                          label="gradeName"
                          @input="FilteredGrade()"
                        ></v-select>
                      </CCol>
                      <CCol sm="6">
                        <label style="text-align: center">Select Subject</label>
                        <v-select
                          v-model="SelectedSubject"
                          :options="subjectOptions"
                          label="subjectName"
                          @input="FilteredData()"
                          class="ml-3"
                        ></v-select>
                      </CCol>
                    </CRow>
                  </CCol>
                </div>
              </div>

              <CRow>
                <CCol sm="4" v-for="item in FilteredQuiz" v-bind:key="item.Id">
                  <CCard
                    class="
                      custom-card-advertise custom-orange-card
                      text-left
                      m-2
                    "
                    @click="GoToDetail(item.Id)"
                  >
                    <span class="custom-type-exam-left">
                      <label class="ml-2"></label>
                    </span>
                    <span class="text-right">
                      <!-- <img
                        v-if="item.ProfilePicturePath!= null"
                        :src="getPic(item)"
                          style="height: 300px"
                          class="custom-bg-advetise"
                        />
                        <img
                        v-else
                          src="../assets/img/Thumbnail.svg"
                          style="height: 300px"
                          class="custom-bg-advetise"
                        /> -->
                      <img
                        src="../assets/img/icon/calculator.svg"
                        style="height: 200px"
                        class="custom-bg-advetise"
                      />
                    </span>

                    <div class="bg-linear">
                      <label class="custom-text-adv-header ml-3">
                        {{ item.Title }}
                      </label>
                      <!-- <h6 class="ml-3 text-white">by {{ item.Teacher }}</h6>
                      <h6 class="ml-3 text-white">
                        {{ item.StartDate | moment("DD MMMM YYYY") }} (
                        {{ item.StartDate | moment("dddd") }} )
                      </h6>
                      <h6 class="ml-3 text-white mb-3">
                        {{ item.start | moment("hh:mm") }} -
                        {{ item.end | moment("hh:mm") }}
                      </h6> -->
                    </div>
                  </CCard>
                </CCol>
              </CRow>
            </CContainer>
          </div>
        </div>
      </CRow>

      <CRow v-if="SecondarySchool === true">
        <div class="card-custom-web">
          <div class="text-center">
            <h1 class="ml-5 mt-5 custom-64px text-center d-sm-down-none">
              <strong>Available Quiz to Participate</strong>
            </h1>

            <h1 class="ml-5 mt-5 custom-24px text-center d-md-none">
              <strong>Available Quiz to Participate</strong>
            </h1>

            <label class="ml-2 mr-2 d-sm-down-none"
              >Choose the class that match with time and interest.</label
            >
            <label class="ml-2 mr-2 d-md-none"
              >Choose the class that match with time and interest.</label
            >

            <br />
            <CContainer>
              <div class="mt-5 mb-3">
                <div class="">
                  <CCol sm="12" class="">
                    <CRow class="">
                      <CCol sm="6">
                        <label style="text-align: center"> Select Grade</label>
                        <v-select
                          v-model="SelectedGrade"
                          :options="gradeOptions"
                          label="gradeName"
                          @input="FilteredGrade()"
                        ></v-select>
                      </CCol>
                      <CCol sm="6">
                        <label style="text-align: center">Select Subject</label>
                        <v-select
                          v-model="SelectedSubject"
                          :options="subjectOptions"
                          label="subjectName"
                          @input="FilteredData()"
                          class="ml-3"
                        ></v-select>
                      </CCol>
                    </CRow>
                  </CCol>
                </div>
              </div>

              <CRow>
                <CCol sm="4" v-for="item in FilteredQuiz" v-bind:key="item.Id">
                  <CCard
                    class="
                      custom-card-advertise custom-orange-card
                      text-left
                      m-2
                    "
                    @click="GoToDetail(item.Id)"
                  >
                    <span class="custom-type-exam-left">
                      <label class="ml-2"></label>
                    </span>
                    <span class="text-right">
                      <!-- <img
                        v-if="item.ProfilePicturePath!= null"
                        :src="getPic(item)"
                          style="height: 300px"
                          class="custom-bg-advetise"
                        />
                        <img
                        v-else
                          src="../assets/img/Thumbnail.svg"
                          style="height: 300px"
                          class="custom-bg-advetise"
                        /> -->
                      <img
                        src="../assets/img/icon/calculator.svg"
                        style="height: 200px"
                        class="custom-bg-advetise"
                      />
                    </span>

                    <div class="bg-linear">
                      <label class="custom-text-adv-header ml-3">
                        {{ item.Title }}
                      </label>
                      <!-- <h6 class="ml-3 text-white">by {{ item.Teacher }}</h6>
                      <h6 class="ml-3 text-white">
                        {{ item.StartDate | moment("DD MMMM YYYY") }} (
                        {{ item.StartDate | moment("dddd") }} )
                      </h6>
                      <h6 class="ml-3 text-white mb-3">
                        {{ item.start | moment("hh:mm") }} -
                        {{ item.end | moment("hh:mm") }}
                      </h6> -->
                    </div>
                  </CCard>
                </CCol>
              </CRow>
            </CContainer>
          </div>
        </div>
      </CRow>
    </div>

    <div class="bg-white">
      <CContainer>
        <CRow>
          <CCol sm="4">
            <div class="text-left custom-24px ml-4 mt-5">COMPANY</div>
            <label class="custom-16px text-black ml-4 mt-4"
              ><strong>About Us</strong></label
            >
            <br />
            <label class="custom-16px text-black ml-4"
              ><strong>Contact Us</strong></label
            >
            <br />
            <label class="custom-16px text-black ml-4"
              ><strong>Terms and Condition</strong></label
            >
          </CCol>
          <CCol sm="4">
            <div class="text-left custom-24px ml-4 mt-5">CONTACT US</div>
            <label class="custom-16px text-black ml-4 mt-4"
              ><strong>Location</strong></label
            >
            <br />
            <label class="text-black ml-4"
              >Pickiddo Sdn Bhd The Square@One City, T1-14-13,Jalan USJ25/1C,
              47650 UEP Subang Jaya, Selangor Darul Ehsan</label
            >
            <br />
            <label class="custom-16px text-black ml-4"
              ><strong>Email</strong></label
            >
            <br />
            <label class="text-black ml-4">info@pickiddo.com</label>
            <br />
            <label class="custom-16px text-black ml-4"
              ><strong>Office Number</strong></label
            >
            <br />
            <label class="text-black ml-4">+603 50360548</label>
          </CCol>
          <CCol sm="4">
            <div class="text-left custom-24px ml-4 mt-5">FOLLOW US</div>
            <label class="custom-16px text-black ml-4 mt-4"
              ><img src="../assets/img/icon/twitter.svg" class="mr-2" />
              @pickiddo</label
            >
            <br />
            <label class="custom-16px text-black ml-4"
              ><img
                src="../assets/img/icon/instagram.svg"
                class="mr-2"
              />@pickiddo</label
            >
            <br />
            <label class="custom-16px text-black ml-4"
              ><img
                src="../assets/img/icon/facebook.svg"
                class="mr-2"
              />@pickiddo</label
            >
            <br />
            <label class="custom-16px text-black ml-4"
              ><img src="../assets/img/icon/whatsap.svg" class="mr-2" />+60
              10-659 7700</label
            >
          </CCol>
        </CRow>
      </CContainer>
    </div>
  </div>
</template>
      
      
      
      
      <script>
import Vue from "vue";
import vSelect from "vue-select";
import { Carousel3d, Slide } from "vue-carousel-3d";
import AnimatedNumber from "animated-number-vue";
import backgroundUrl from "../assets/img/bg3.png";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

// import Translator from "vue-gtranslate";
// import "vue-gtranslate/translator.css";

Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

import Mainlayout from "../containers/TheHeaderNew.vue";

import VueAgile from "vue-agile";
Vue.use(VueAgile);
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
// in component

import AOS from "aos";
import "aos/dist/aos.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import _ from "lodash";
import $ from "jquery";

import MenuIcon from "vue-material-design-icons/Menu.vue";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
new Vue({
  el: "#navbar",

  data() {
    return {
      view: {
        topOfPage: true,
      },
    };
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.pageYOffset > 400) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
          el.setAttribute(
            "style",
            "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
          );
        }
      } else {
        if (!this.view.topOfPage) this.view.topOfPage = true;
        el.setAttribute(
          "style",
          "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
        );
      }
    },
  },
});

export default {
  name: "Login",
  components: {
    Carousel3d,
    Slide,
    VueCal,
    MenuIcon,
    agile: VueAgile,
    Mainlayout,
    AnimatedNumber,
    backgroundUrl,
    PulseLoader,
  },
  data() {
    return {
      slides: 5,
      quiz: [],

      detail: [],
      FilteredQuiz: [],

      SearchQuery: "",

      popupclassdetail: false,

      isShowPrimary: true,
      primary: [],
      PrimarySchool: true,
      isShowPrim: false,

      isShowSecondary: false,
      secondary: [],
      SecondarySchool: false,

      ModalPopup: false,

      subjects: [],
      grades: [],
      subjectOptions: [],
      gradeOptions: [],
      SelectedSubject: "All subject",
      SelectedGrade: "All grade",

      StudentName: "",
      popupquizname: false,
      popuplogin: false,

      gradePrimary: [],

      // answer quiz
    };
  },
  created() {
    AOS.init();
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  async mounted() {
    await this.GetQuizList();
    // this.GetAllPackages();
    this.GetPrimaryQuizGrade();
    this.GetSecondaryQuizGrade();
    this.GetSubject();
    this.GetGrade();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {},

  methods: {
    getBadge(status) {
      switch (status) {
        case "Active":
          return "success";
        case "Inactive":
          return "secondary";
        case "Pending":
          return "warning";
        case "Banned":
          return "danger";
        default:
          "primary";
      }
    },
    onScroll() {
      // Get the current scroll position
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return;
      }
      // Here we determine whether we need to show or hide the navbar
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition;
    },
    handleScroll() {
      if (window.pageYOffset > 1000) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
        } else {
          this.view.topOfPage = true;
        }
      }
    },
    GetPrimaryQuizGrade() {
      this.$API
        .get(this.$GradeQuizPrimary, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.gradePrimary = response.data;
          }
        });
    },
    GetSecondaryQuizGrade() {
      this.$API
        .get(this.$GradeQuizSecondary, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.gradeSecondary = response.data;
          }
        });
    },
    GetQuizList() {
      this.$API
        .get(this.$AllQuizList, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.quiz = response.data;
            this.FilteredQuiz = this.quiz;

            var scheduleNames = _.uniq(_.map(response.data, "gradeName"));
            scheduleNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.gradeOptions = scheduleNames;
            this.gradeOptions.unshift("SELECT GRADE");

            var subjectNames = _.uniq(_.map(response.data, "subjectName"));
            subjectNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.subjectOptions = subjectNames;
            this.subjectOptions.unshift("SELECT SUBJECT");
          }
        });
    },
    GetDetailQuiz(quizId) {
      return this.$API
        .get(this.$QuizPreview + "?quizId=" + quizId)
        .then(
          function (response) {
            this.detail = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    GoToDetail(quizId) {
      this.popupclassdetail = true;
      this.popupquizname = false;
      this.popuplogin = false;
      this.GetDetailQuiz(quizId);
    },
    GoToQuizName(quizId) {
      console.log("quiz" + quizId);
      this.popupquizname = false;
      this.popupclassdetail = false;
      this.popuplogin = true;
      this.GetDetailQuiz(quizId);
    },
    GoBack() {
      this.popupclassdetail = false;
    },
    ShowPrimary() {
      this.PrimarySchool = true;
      this.SecondarySchool = false;
      this.isShowPrimary = true;
      this.isShowSecondary = false;
    },
    ShowSecondary() {
      this.PrimarySchool = false;
      this.isShowPrimary = false;
      this.isShowSecondary = true;
      this.SecondarySchool = true;
    },
    getPic(item) {
      return "https://pickiddo.com/" + item.ProfilePicturePath;
    },
    OpenModal() {
      this.ModalPopup = true;
    },
    async GetSubject() {
      this.$API
        .get(this.$ListSubject, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjects = response.data;
          }
        });
    },
    async GetGrade() {
      this.$API
        .get(this.$ListGrade, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
    },
    FilteredData() {
      console.log("masuk" + this.SelectedSubject);
      this.FilteredQuiz = this.quiz;
      if (this.SelectedSubject !== "ALL SUBJECT")
        this.FilteredQuiz = _.filter(
          this.FilteredQuiz,
          (item) => item.subjectName === this.SelectedSubject
        );
    },
    FilteredGrade() {
      console.log("masuk" + this.SelectedGrade);
      this.FilteredQuiz = this.quiz;
      if (this.SelectedGrade !== "ALL GRADE")
        this.FilteredQuiz = _.filter(
          this.FilteredQuiz,
          (item) => item.gradeName === this.SelectedGrade
        );
    },
    InsertManualStudent(Id) {
      const formData = new FormData();

      formData.append("Name", this.StudentName);

      return this.$API
        .post(this.$RegisterStudentQuiz, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentId = response.data;
            this.StudentStartQuiz(Id, this.studentId);
          } else {
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
            this.ErrorMessageNotComplete = true;
          }
        });
    },
    StudentStartQuiz(Id, studentId) {
      const formData = new FormData();
      formData.append("quizId", Id);
      formData.append("studentId", this.studentId);

      return this.$API
        .post(this.$StudentStartQuiz, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            var startId = response.data;
            this.getNow(
              this.detail.d,
              this.detail.h,
              this.detail.m,
              this.detail.s
            );
            console.log(this.timestamp);
            this.GoToQuiz(startId, this.timestamp, Id, studentId);
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
          }
        });
    },
    getNow: function (d, h, m, s) {
      const today = new Date();
      const date =
        today.getFullYear() +
        "-" +
        ("0" + (today.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + (today.getDate() + d)).slice(-2);
      let Chour = today.getHours() + h;
      let Cminute = today.getMinutes() + m;
      let Csecond = today.getSeconds() + s;
      if (Csecond > 60) {
        Csecond -= 60;
        Cminute += 1;
      } else if (Cminute > 60) {
        Cminute -= 60;
        Chour += 1;
      } else {
      }
      const time =
        ("0" + Chour).slice(-2) +
        ":" +
        ("0" + Cminute).slice(-2) +
        ":" +
        ("0" + Csecond).slice(-2);
      const dateTime = date + "T" + time;
      this.timestamp = dateTime;
    },
    GoToQuiz(startId, timestamp, Id, studentId) {
      this.$router.push(
        "/AnswerQuiz?quizId=" +
          Id +
          "&studentId=" +
          studentId +
          "&startId=" +
          startId +
          "&endTime=" +
          timestamp
      );
    },
  },
};
</script>
          <style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");

.c-header {
  /* background: rgb(23, 77, 124);
        background: linear-gradient(92deg, #174d7c, #1b7682);
        border-bottom: 0.01px solid #1a6783;
        border-bottom: 1px solid #636f83; */

  background: transparent;
  border-bottom: 0;
  border-bottom: 0;
  /* color: #fff; */
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  font-family: "Montserrat", sans-serif;
}
body {
  font-family: "Montserrat", sans-serif;
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  font-family: "Montserrat", sans-serif;
}
label {
  font-family: "Montserrat", sans-serif;
}

body nav.onScroll {
  box-shadow: 0 0 10px #aaa;
  background-color: rgb(255, 255, 255);
  font-family: "Montserrat";
  font-style: normal;
}
body nav.onScroll ul li {
  color: #10b761;
}
body nav ul {
  margin-left: 3em;
  width: 25%;
  display: flex;
  justify-content: space-between;
}
body nav ul li {
  cursor: pointer;
  font-weight: 600;
  list-style-type: none;
  color: white;
}
body {
  top: 0 !important;
  font-family: "Montserrat", sans-serif;
}

input {
  border-bottom: 2px solid #fff;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: -webkit-fill-available;
  -webkit-text-fill-color: white !important;
}
input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.custom-user-input {
  /* Body/1/Semibold */

  display: flex;
  justify-content: center;
  flex-flow: row nowrap;
}

.js-click:active {
  background: #e8f4ff;
  border-radius: 20px;
  border: 1px solid #e8f4ff;
}

.js-click:focus {
  background: #e8f4ff;
  border-radius: 20px;
  border: 1px solid #e8f4ff;
}
.vs--searchable .vs__dropdown-toggle {
  cursor: text;
  border: none;
  border-bottom: 1px solid #ddd;
}
.v-select {
  position: relative;
  font-family: inherit;
  border: none;
  min-width: 200px;
}

.custom-card-advertise{
  width:100%;
}

.custom-popup-class {
    position: fixed;
    top: 0;
    right: 0;
    width: 24%;
    z-index: 1;
}
</style>